import {
    SessionClearAction, SessionLogoutAction
} from './session.actions';

export type SessionState = {
    isIdleTimedOut: boolean
    isSessionExpired: boolean
};

export const INITIAL_SESSION_STATE: SessionState = {
    isIdleTimedOut: false,
    isSessionExpired: false
};

export type SessionActions =
    | SessionClearAction
    | SessionLogoutAction;
